import React from 'react';
import IInfoBox from './IInfoBox';
import { classNames } from '@features/utils/reactFunctions';
import * as style from './InfoBoxStyle.module.scss'

const InfoBox: React.FunctionComponent<IInfoBox> = (props: IInfoBox) => {
  return (
    <div
      className={
        classNames(style.infoBox, props.bold && style.bold, props.error && style.error, props.className)
      }
    >
      {props.headline && <h3 className={style.headline}>{props.headline}</h3>}
      {props.children}
    </div>
  );
};

export default React.memo(InfoBox);
